import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    const r = await login(form.email, form.password);
    setBusy(false);
    if (r.ok) {
      toast.success(`Welcome back, ${r.user.name}!`);
      nav(r.user.role === "admin" ? "/admin" : "/dashboard");
    } else { toast.error(r.error); }
  };

  return (
    <div data-testid="login-page" className="pt-32 pb-24 container mx-auto px-4 max-w-md">
      <h1 className="font-display font-black text-4xl mb-6">Welcome back.</h1>
      <form onSubmit={submit} className="space-y-4 bg-white border border-zinc-200 rounded-2xl p-7">
        <input required type="email" placeholder="Email" value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          data-testid="login-email" className="w-full px-4 py-3 border border-zinc-300 rounded-lg" />
        <input required type="password" placeholder="Password" value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          data-testid="login-password" className="w-full px-4 py-3 border border-zinc-300 rounded-lg" />
        <button type="submit" disabled={busy} data-testid="login-submit"
          className="w-full px-6 py-3 rounded-full bg-gradient-brand text-white font-bold disabled:opacity-50">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="text-center text-sm text-zinc-500 mt-5">
        New here? <Link to="/register" className="font-semibold text-[#FF007F]">Create an account</Link>
      </p>
    </div>
  );
}
